module.exports = {
    // basic
    'help-document': 'help document',

    // raw
    'video-tag-not-supported': 'Your browser does not support the video tag.',
    'help-list-help': `
        If you have further questions, please contact us at <a class="alert-link" href="mailto:ops@welldrive.com">ops@welldrive.com</a>, <a class="alert-link" href="tel:8777048270">(877) 704-8270</a> or <a class="alert-link" href="tel:8557048270">(855) 704-8270 (alternate)</a>.
    `,
    
    // template
};
